<template>
    <div class="row">
        <main class="col-sm-9">
            <div class="container">
                <div class="row product-wrapper card-product" v-for="product in cart.products">
                    <div class="basket-item__remove" title="Remove From Basket" @click="remove(product.id)">
                        x
                        <!--                        <i class="fa fa-trash"></i>-->
                    </div>
                    <div class="basket-item__image col-12 col-lg-2">
                        <img :alt="product.name"
                             :src="'/images/products/medium_'+product.id+'.jpg'"
                             width="80" height="80">
                    </div>
                    <div class="details col-8 col-lg-10">
                        <div class="row">
                            <div class="col-lg-6 col-md-12 basket-item__details">
                                <div class="basket-item__title">
                                    <a
                                        :href="'/product/'+product.id"
                                        :title="product.name">{{ product.name }}</a>
                                </div>
                                <!--                                <p class="basket-item__meta" v-html="product.short_src"> </p>-->
                                <p class="basket-item__meta">{{ product.price }}грн.</p>
                            </div>
                            <div class="col-md-6 col-lg-3 cart-qty">
                                <div class="">
                                    <span class="cart-qty__btn cart-qty__btn__decrease"
                                          @click="decrease(product.id)"
                                          title="Decrease">-</span>
                                    <span class="cart-qty__btn cart-qty__value">{{ product.qty }}</span>
                                    <span class="cart-qty__btn cart-qty__btn__increase"
                                          @click="increase(product.id)"
                                          title="Increase">+</span>

                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3">

                                <div class="price">
                                    <!--                                    <h5 class="price&#45;&#45;fullprice i-product-full-price" data-cy="item-price">{{translate('discount')}}-->
                                    <!--                                        15%</h5>-->
                                    <h4 class="price--fullprice i-product-full-price" data-cy="item-price">
                                        {{ product.subtotal }} грн.</h4>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <aside class="col-sm-3">
            <!--Coupon-->
            <!--            <div class="card mb-3">-->
            <!--                <div class="card-body">-->
            <!--                    <form>-->
            <!--                        <div class="form-group">-->
            <!--                            <label>Have coupon?</label>-->
            <!--                            <div class="input-group">-->
            <!--                                <input type="text" class="form-control" name="" placeholder="Coupon code">-->
            <!--                                <span class="input-group-append">-->
            <!--				<button class="btn btn-primary">Apply</button>-->
            <!--			</span>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </form>-->
            <!--                </div> -->
            <!--            </div> -->
            <div class="card">
                <div class="card-body">
                    <!--                    <p class="alert alert-success">Тут можна щось написати. </p>-->
                    <dl class="dlist-align">
                        <dt>{{ translate('qty') }}:</dt>
                        <dd class="text-right">{{ cart.count }}</dd>
                    </dl>
                    <dl class="dlist-align">
                        <dt>{{ translate('subtotal') }}:</dt>
                        <dd class="text-right"><strong>{{ cart.total }} грн.</strong></dd>
                    </dl>
<!--                                        <dl class="dlist-align">-->
<!--                                            <dt>{{translate('discount')}}:</dt>-->
<!--                                            <dd class="text-right text-danger">- $10.00</dd>-->
<!--                                        </dl>-->
<!--                                        <dl class="dlist-align">-->
<!--                                            <dt class="h6">{{translate('total')}}:</dt>-->
<!--                                            <dd class="text-right text-dark b"><strong>{{cart.total}} грн.</strong></dd>-->
<!--                                        </dl>-->
                    <hr>
                    <p class="text-center mb-3">
                        <!--                        <img src="/img/payments.png" height="26">-->
                    </p>
                    <a v-if="cart.count>0" href="/checkout" class="btn btn-primary btn-block">
                        {{ translate('checkout') }}</a>
                    <a :href="previousUrl" class="btn btn-light btn-block">{{ translate('continue_shopping') }}</a>
                </div> <!-- card-body.// -->
            </div> <!-- card.// -->
        </aside>

    </div>
</template>

<script>
export default {
    name: 'Cart',
    props: ['locale'],

    data () {
        return {
            url: '/cart/modify',
            previousUrl: '/',
            cart: {},
            trans: {
                'qty': {
                    'ru': 'Товаров',
                    'uk': 'Товарів',
                },
                'subtotal': {
                    'ru': 'На сумму',
                    'uk': 'На суму',
                },
                'discount': {
                    'ru': 'Скидка',
                    'uk': 'Знижка',
                },
                'total': {
                    'ru': 'Всего',
                    'uk': 'Загалом',
                },
                'checkout': {
                    'ru': 'Оформить заказ',
                    'uk': 'Оформити замовлення',
                },
                'continue_shopping': {
                    'ru': 'Продолжить покупки',
                    'uk': 'Продовжити покупки',
                },
            }
        }
    },
    mounted () {
        this.getCart()
    },
    methods: {
        translate (sentence) {
            return this.trans[sentence][this.locale]
        },
        decrease (id) {
            axios
                .post(this.url, { action: 'decrease', id: id })
                .then(response => {
                    this.cart = response.data.cart
                    this.previousUrl = response.data.previousUrl
                })
                .catch()
        },
        increase (id) {
            axios
                .post(this.url, { action: 'increase', id: id })
                .then(response => {
                    this.cart = response.data.cart
                    this.previousUrl = response.data.previousUrl
                })
                .catch()
        },
        remove (id) {
            console.log(this.cart.products)
            let prod = this.cart.products.find(item => {
                // console.log(item.id)
                return item.id == id
            })
            // console.log(prod)
            // return

            axios
                .post(this.url, { action: 'remove', id: id })
                .then(response => {
                    this.cart = response.data.cart
                    this.previousUrl = response.data.previousUrl

                    window.dataLayer.push({ ecommerce: null })            //Clear the previous ecommerce object
                    window.dataLayer = window.dataLayer || []
                    // console.log(key, action)

                    window.dataLayer.push({
                        'event': 'remove_from_cart',
                        'ecommerce': {
                            'items': [
                                {
                                    'item_name': prod.name,
                                    'item_id': prod.id,
                                    'price': prod.price,
                                    //     'item_brand': '{{$product->brand->name}}',
                                    // @if($product->catalog->parent)
                                    //     'item_category': '{{$product->catalog->parent->menu_name}}',
                                    //     'item_category2': '{{$product->catalog->menu_name}}',
                                    // @else
                                    // 'item_category': '{{$product->catalog->menu_name}}',
                                    // @endif
                                    'item_list_name': 'Cart',
                                    'quantity': prod.qty,
                                    'google_business_vertical': 'retail'
                                }
                            ],

                        }
                    })
                })
                .catch()
        },

        getCart () {
            axios
                .post(this.url, { action: 'get' })
                .then(response => {
                    this.cart = response.data.cart
                    this.previousUrl = response.data.previousUrl

                })
                .catch()
        },
    },
    watch: {
        cart () {
            document.getElementById('cart_count').innerText = this.cart.count
            document.getElementById('cart_total').innerText = this.cart.total
        }
    },

}

</script>

<style scoped>
.product-description {
    display: flex;
    justify-content: flex-start;
}

.product-wrapper {
    margin-bottom: 10px;
}

.basket-item__title {
    font-size: 1.1rem;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 5px;
    margin-top: 0;
}

.basket-item__meta {
    font-size: 1em;
    color: grey;
    font-weight: 400;
    margin-top: 0;
}

.cart-qty {
    display: flex;
    justify-content: center;
    align-items: center;
}

.cart-qty__btn {
    width: 30px;
    cursor: pointer;
}

.cart-qty__btn, cart-qty__value {
    display: inline-block;
    /*-webkit-appearance: none;*/
    border: 1px solid #999;
    border: 1px solid grey;
    /*border: none;*/
    background: #fff;
    float: left;
    height: 35px;
    line-height: 35px;
    text-align: center;
}

.cart-qty__btn__decrease {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    background-color: #efefef;
}

.cart-qty__btn__increase {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    background-color: #efefef;
}


.cart-qty__value {
    border-left: none;
    border-right: none;
}


.card-product {
    position: relative;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    padding: 0.55rem;
}

.card-product:hover {
    -webkit-box-shadow: 0 4px 15px rgba(153, 153, 153, 0.3);
    box-shadow: 0 4px 15px rgba(153, 153, 153, 0.3);
    -webkit-transition: .5s;
    transition: .5s;
}

.basket-item__remove {
    color: red;
    position: absolute;
    right: 5px;
    top: 0px;
    z-index: 45;
    font-size: larger;
    cursor: pointer;
}

.price {
    margin-top: 1rem;
}

.itemside {
    position: relative;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    width: 100%;
}

[class*="dlist-"] {
    margin-bottom: 5px;
}

.dlist-align dt {
    width: 90px;
    float: left;
    word-wrap: break-word;
}

.itemside img {
    -o-object-fit: contain;
    object-fit: contain;
}


</style>
